module.exports = __webpack_public_path__ + "img/f99672e.png";